import { Box } from '@material-ui/core';
import { Agent, formatDateTimeReadable } from '@nemuru-eng/js-api-client';

import { OverviewDetailRow } from '../../../../shared/components/OverviewDetailRow';
import { Text } from '../../../../shared/components/Text';

export const Details = ({ currentAgent }: { currentAgent: Agent }) => {
  return (
    <Box display={'flex'} flexDirection={'column'}>
      <OverviewDetailRow field={<Text tId={'AGENT_ID'} />} value={currentAgent.id} copyButton />
      <OverviewDetailRow field={<Text tId={'CREATED_AT'} />} value={formatDateTimeReadable(currentAgent.createdAt)} />
    </Box>
  );
};
